import { max } from 'moment';
import styled, { keyframes } from "styled-components";
import { ThemeType } from "../../types/Theme";

const blink = keyframes`
  0% { opacity: 0; }
  50% { opacity: 1; }
  100% { opacity: 0; }
`;

const ringBell = keyframes`
  0% { transform: rotate(0); }
  1% { transform: rotate(30deg); }
  3% { transform: rotate(-28deg); }
  5% { transform: rotate(34deg); }
  7% { transform: rotate(-32deg); }
  9% { transform: rotate(30deg); }
  11% { transform: rotate(-28deg); }
  13% { transform: rotate(26deg); }
  15% { transform: rotate(-24deg); }
  17% { transform: rotate(22deg); }
  19% { transform: rotate(-20deg); }
  21% { transform: rotate(18deg); }
  23% { transform: rotate(-16deg); }
  25% { transform: rotate(14deg); }
  27% { transform: rotate(-12deg); }
  29% { transform: rotate(10deg); }
  31% { transform: rotate(-8deg); }
  33% { transform: rotate(6deg); }
  35% { transform: rotate(-4deg); }
  37% { transform: rotate(2deg); }
  39% { transform: rotate(-1deg); }
  41% { transform: rotate(1deg); }

  43% { transform: rotate(0); }
  100% { transform: rotate(0); }
`;

export const MainHeader = styled.header`
  width: 100%;

  .headerContainer {
    width: 100%;
    margin-bottom: 16px;
    display: grid;
    grid-template-columns: 50% 5% 45%;
    justify-content: space-between;
    align-items: center;
    position: relative;
    flex-wrap: wrap;
    background: ${({ theme }) => theme.colors.white};
    @media (max-width: 768px) {
      grid-template-columns: 40% 5% 55%;
    }

    .logoHorizontal {
      display: flex;
      align-items: center;
      border-top-right-radius: 32px;
      height: 100%;
      padding: 0rem 2rem;
      width: auto;
      background-color: ${({theme}) => theme.colors.background2};

      svg {
        height: 6rem;
        fill: ${(props) => props.theme.colors.primary};
      }
    }

    .headerEfeito{
      background-color: transparent;
      height: 100%;
      width: 100%;
      border-bottom-left-radius: 32px;
      box-shadow: 0px 35px 0px 0px ${({ theme }) => theme.colors.background2};
      @media (max-width: 768px) {
        box-shadow: 0px 15px 0px 0px ${({ theme }) => theme.colors.background2};
      }
    }

    .paginacaoContainer {
      max-width: 100%;
      background-color: ${({theme}) => theme.colors.background2};
      height: 100%;
      display: flex;
      align-items: center;
      padding: 0rem 10rem;
      border-top-right-radius: 32px;
    }

    .botoesContainer {
      padding: 3rem 10rem;
      display: flex;
      align-items: center;
      justify-content: end;
      gap: 2rem;
      color: ${(props) => props.theme.colors.primary};
      .foto {
        cursor: pointer;
      }
      @media (max-width: 768px) {
        padding: 2rem 2rem;
        display: grid;
        grid-template-columns: 95px 26px 26px 30px;
        gap: 1rem;
      }
      .botaoTokensIa {
        display: flex;
        height: 22px;
        align-items: center;
        justify-content: center;
        position: relative;
        border: none;
        background: ${(props) => props.theme.colors.borderGradient};
        border-radius: 16px;
        padding: 0px 16px;
        gap: 4px;
        @media (max-width: 768px) {
          padding: 0 8px;
        }
        
        &::after {
          content: "";
          position: absolute;
          inset: 1px;
          background: ${(props) => props.theme.colors.white};
          border-radius: 19px;
          z-index: 0;
        }
        
        > * {
          position: relative;
          z-index: 1;
          color: ${(props) => props.theme.colors.tertiary};
        }

        .tokens-ia {
          width: 12px;
          height: 12px;

          @media (max-width: 768px) {
            width: 2rem;
            height: 2rem;
          }
        }
      }

      .icone{
        display: flex;
        align-items: center;
        justify-content: center;
        width: auto;
        height: 32px;

        .blink{
          position: relative;
          &:after{ 
            content: "";
            position: absolute;
            top: 0;
            right: 0;
            width: 1rem;
            height: 1rem;
            background-color: ${props => props.theme.colors.alert};
            border-radius: 50%;
            z-index: 2;
          }
          &::before {
            content: "";
            position: absolute;
            width: 1rem;
            height: 1rem;
            border-radius: 50%;
            background-color: transparent;
            z-index: 1;
            top: 0;
            right: 0;
            box-shadow: 0px 0px 11px 1px ${props => props.theme.colors.alert};
          }
        }
      }
      .ringBell {
        animation: ${ringBell} 4.7s 8s ease-in-out infinite;
      }
      
      .botao {
        cursor: pointer;
        width: 4rem;
        height: 4rem;

        /* @media (max-width: 768px) {
          width: 6rem;
          height: 6rem;
        } */
      }

      .rotate {
        animation: rotate 0.5s cubic-bezier(0.69, 0.99, 0.49, 0.94);
      }
    }
    
  }

  @media (max-width: 1024px) {
    padding: 0px;

    .headerContainer {

      &::after {
        bottom: 0;
      }
    }

    .botoesContainer {
      .botaoGuia {
        display: contents !important;

        .texto {
          display: none;
        }
      }
    }
  }
`;

export const ModalUsuarioContainer = styled.div`
  .modal-container {
    padding: 2rem 5rem;
    .icones-container {
      display: flex;
      flex-direction: column;
      .icone-container {
        color: ${(props) =>
          props.theme.mode == "light"
            ? props.theme.colors.primary
            : props.theme.colors.tertiary};
        display: flex;
        align-items: center;
        justify-content: flex-end;
        gap: 4px;
        width: 100%;
        padding: 1rem 0;
        .icone {
          width: 100%;
          cursor: pointer;
          display: flex;
          align-items: center;
          gap: 1rem;
          > a {
            display: contents;

            svg{
              fill: ${(props) =>
                props.theme.mode == "light"
                ? props.theme.colors.primary
                : props.theme.colors.tertiary};
            }
          }
          svg {
            width: 4rem;
          }
          span {
            white-space: nowrap;
            text-align: left;
            flex-grow: 1;
          }
          .rotate {
            animation: rotate 0.5s cubic-bezier(0.69, 0.99, 0.49, 0.94);
          }
          .icone-submenu{
            display: flex;
            align-items: center;
            justify-content: flex-start;
            gap: 4px;
          }
        }
        &:first-child {
          position: relative;
          padding-bottom: 3rem;
          &::after {
            content: "";
            position: absolute;
            bottom: 0;
            border-radius: 100px;
            background-color: ${(props) =>
              props.theme.mode == "light"
                ? props.theme.colors.elements
                : props.theme.colors.tertiary};
            width: 100%;
            height: 2px;
          }
        }
        &:nth-child(2) {
          padding-top: 3rem;
        }
      }
      .configs-perfil{
        display: flex;
        flex-direction: column;
        gap: 1rem;
      }
    }
  }
`;

export const ModalTokensIaContainer = styled.div<{ theme: ThemeType }>`
  position: relative;
  background: ${(props) => props.theme.colors.borderGradient};
  border-radius: 30px;
  padding: 1px;
  
  &::after {
    content: "";
    position: absolute;
    inset: 1px;
    background: ${(props) => props.theme.colors.white};
    border-radius: 30px;
    z-index: 0;
  }
  
  > * {
    position: relative;
    z-index: 1;
  }
  
  .modal-tokens-ia {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding: 32px 24px;
    gap: 16px;
    
    .header-modal-tokens{
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 8px;
    
    .titulo {
      color: ${({ theme }) => theme.colors.secondary};
      font-weight: bold;
    }
    .subtitulo-criacao {
      color: ${({ theme }) => theme.colors.tertiary};
    }
  }
  .quantidade-tokens{
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 4px;
    position: relative;
    border: none;
    background: ${(props) => props.theme.colors.borderGradient};
    border-radius: 16px;
    padding: 8px 16px;

    &::after {
      content: "";
      position: absolute;
      inset: 1px;
      background: ${(props) => props.theme.colors.white};
      border-radius: 16px;
      z-index: 0;
    }

    > * {
      position: relative;
      z-index: 1;
    }

    .tokens-ia {
      width: 12px;
      height: 12px;

      @media (max-width: 768px) {
        width: 2rem;
        height: 2rem;
      }
    }

    p{
      margin: 0;
    }
  }
  }
`;
export const ModalAjudaContainer = styled.div<{ theme: ThemeType }>``;

export const ModalNotificacoesContainer = styled.div<{ theme: ThemeType }>``;